import styled, { css, keyframes } from "styled-components";
import { mediaQuery } from "../utils";

const { PUBLIC_URL } = process.env;

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

const Freedom = styled.div`
  animation: ${rotate} 20s linear infinite;
  background-image: url(${`${PUBLIC_URL}/assets/images/shnitke/cinema/circle.jpg`});
  background-repeat: no-repeat;
  background-size: contain;
  height: 180px;
  left: 35%;
  position: relative;
  transform: translateX(-35%);
  width: 180px;

  ${mediaQuery(
    "phone",
    css`
      left: 25%;
      transform: translateX(-25%);
    `,
  )}
`;

export default Freedom;
